import { Box, CircularProgress } from '@mui/material';

/**
 * Circular progress indicator that expands to fill its parent.
 * @returns {React.FunctionComponent} React element that contains the component.
 */
function Loader() {
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  );
}

export default Loader;
